import {Config} from '../../../constants/Config'
import {IMG_RESCALED} from '../../../models/editor/imgHistoryItemAction'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {
  addImageHistoryItem,
  persistScale,
  setScale,
} from '../../../stores/editor/editor.reducer'
import InputSlider from '../../toolbox/sliders/InputSlider'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function SizeControlsPhoto({open, onBackClick}: ControlsProps) {
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      <InputSlider
        fullWidth
        xMin={Config.minZoom}
        xMax={3}
        xStep={0.02}
        x={selectedImage?.scale ?? 1}
        onDragStart={() => {
          if (selectedImage) {
            dispatch(persistScale({id: selectedImage.id}))
          }
        }}
        onDragEnd={(value: number) => {
          if (selectedImage) {
            const historyImage = {
              ...selectedImage,
              scale: value,
              origScale: selectedImage.scale,
            }

            dispatch(
              addImageHistoryItem({
                item: {img: historyImage, action: IMG_RESCALED},
              }),
            )
          }
        }}
        onChange={(value: number) => {
          if (selectedImage) {
            dispatch(setScale({id: selectedImage.id, scale: value}))
          }
        }}
      />
    </ControlsBase>
  )
}
